export function getOfferType(type) {
  switch (type) {
    case "Medical":
      return "MED";
    case "Dental":
      return "DEN";
    case "Vision":
      return "VIS";
    default:
      return null;
  }
}

/**
 * Prefixes a download's file name with the client id, so a menu that lands in a
 * user's Downloads folder still says which client it belongs to. Menu file names
 * are persisted per document (and some are built client-side), so the prefix is
 * applied at download time rather than at generation time - that way it covers
 * documents that were generated before this existed.
 *
 * Matches the `{clientId} - {name}` shape already used by the contribution model
 * export. Re-prefixing is a no-op, so it is safe to call on an already-prefixed name.
 */
export function withClientIdFileName(fileName, clientId) {
  if (!fileName) {
    return fileName;
  }

  const id = String(clientId ?? "").trim();
  if (!id || fileName.startsWith(`${id} - `)) {
    return fileName;
  }

  return `${id} - ${fileName}`;
}

export function getBenefitGroup(plan) {
  return plan?.benefitGroup?.trim() || "";
}

export function getPlansForDocument(menus = [], documentType) {
  const offerType = getOfferType(documentType);
  return (menus || []).filter((plan) => plan.planOfferType === offerType);
}

export function hasMultipleBenefitGroups(plans = []) {
  return new Set(plans.map(getBenefitGroup).filter(Boolean)).size > 1;
}

/**
 * Appends the replacement-plan note to a termed plan's display name, so a user
 * reading a dropdown knows whose premium the comparison column will show.
 * Returns the plan untouched when there is nothing to add.
 */
export function formatPlanDisplayName(plan) {
  if (!plan?.isTermed || !plan?.hasReplacementPlan) {
    return plan;
  }

  const replacementPlan = plan.replacementPlanName || plan.replacementPlanId;
  if (!replacementPlan) {
    return plan;
  }

  return {
    ...plan,
    planName: `${plan.planName} - Using replacement premium from ${replacementPlan}`,
  };
}

export function scopePlansByPrimary(plans = [], primaryPlan) {
  const primaryBenefitGroup = getBenefitGroup(primaryPlan);
  if (!primaryBenefitGroup) {
    return plans;
  }

  return plans.filter((plan) => getBenefitGroup(plan) === primaryBenefitGroup);
}